import { render } from "./Auth.vue?vue&type=template&id=2b2805c2"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"
script.render = render

export default script